function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.45 4.5)"
}, /*#__PURE__*/React.createElement("text", {
  fontFamily: "Sarabun-Regular, Sarabun",
  fontSize: "9px",
  transform: "translate(4.404 14)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "10")), /*#__PURE__*/React.createElement("path", {
  d: "M2.695 12.776a.74.74 0 0 0 .012-1.033 4.461 4.461 0 0 1-1.229-3.077v-.287a4.49 4.49 0 0 1 4.49-4.49h6.274l-.858.858a.739.739 0 0 0 0 1.045.739.739 0 0 0 1.045 0l2-2a.7.7 0 0 0 .139-.2l.031-.03-.011-.011a.7.7 0 0 0-.158-.753l-2-2.005a.739.739 0 0 0-1.045 1.045l.58.58h-6a5.968 5.968 0 0 0-5.968 5.968v.287a5.944 5.944 0 0 0 1.65 4.114.736.736 0 0 0 1.048-.011z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.3 12.5a.74.74 0 0 0 .012-1.033 4.461 4.461 0 0 1-1.229-3.077v-.287a4.49 4.49 0 0 1 4.49-4.49h6.274l-.858.858a.739.739 0 0 0 0 1.045.739.739 0 0 0 1.045 0l2-2a.7.7 0 0 0 .139-.2l.031-.03-.011-.011a.7.7 0 0 0-.158-.753l-2-2.005a.739.739 0 0 0-1.045 1.045l.58.58h-6a5.968 5.968 0 0 0-5.968 5.968v.287a5.944 5.944 0 0 0 1.65 4.114.736.736 0 0 0 1.048-.011z"
}));

var SvgNext10 = function SvgNext10(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNext10, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/next10.93767e69.svg";
export { ForwardRef as ReactComponent };